import {selectModeData} from "../../../redux/selectors/editor";
import {ILocalizationData, UpdateModeData, updateModeData} from "../../../redux/slices/editor";
import {connect} from "react-redux";
import {FileDownload} from "@mui/icons-material";
import React from "react";
import {IconButton} from "@mui/material";

export interface ILocalizationTools
{
    localizationData: ILocalizationData
    updateModeData: UpdateModeData
}
function LocalizationTools({localizationData, updateModeData}: ILocalizationTools) {
    return (
        <>
            <IconButton color="inherit" disabled={localizationData.exportJson} onClick={() =>
                updateModeData({exportJson: true})} title="Export localisation data in JSON format">
                <FileDownload/>
            </IconButton>
        </>  
    );
}

const mapStateToProps = (store: never) => ({
    localizationData: selectModeData(store) as ILocalizationData
});
const connected = connect(mapStateToProps, {
    updateModeData
})(LocalizationTools);

export {connected as LocalizationTools};
